import '../styles/Banner.css';

function Banner({ children }) {
	return <div className='kdo-banner'>{children}</div>
}

export default Banner